import { createContext, MutableRefObject } from 'react';

export default createContext<MutableRefObject<HTMLIonContentElement | null> | null>(null);
